import { render, staticRenderFns } from "./selectedLocation.vue?vue&type=template&id=45f35130&"
import script from "./selectedLocation.vue?vue&type=script&lang=js&"
export * from "./selectedLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports